/* Iron+Steel v3 quick view: shared by collection grid cards and product rails. */

/* Quick view modal: loads sections/is-quick-view for a product into a native <dialog>. */
(() => {
  if (window.ISQuickView) return;
  let dialog;

  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'is-qv-dialog';
    dialog.setAttribute('aria-labelledby', 'IsQuickTitle');
    dialog.innerHTML = `
      <button type="button" class="is-qv-dialog__close" aria-label="Close quick view" data-qv-close>
        <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="square"><path d="m5 5 14 14M19 5 5 19"/></svg>
      </button>
      <div class="is-qv-dialog__body" data-qv-body></div>`;
    document.body.appendChild(dialog);
    dialog.querySelector('[data-qv-close]').addEventListener('click', () => close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      if (dialog.trigger) dialog.trigger.focus();
    });
    // Close once the bag drawer takes over after a successful add.
    document.addEventListener('is:product:added', () => {
      if (dialog.open) close();
      // On the cart page the line items are server-rendered; reload so totals and add-ons stay in sync.
      if (document.querySelector('cart-items[data-cart-page]')) setTimeout(() => window.location.reload(), 600);
    });
  };

  const close = () => dialog && dialog.open && dialog.close();

  window.ISQuickView = {
    async open(url, trigger) {
      if (!dialog) build();
      dialog.trigger = trigger;
      const body = dialog.querySelector('[data-qv-body]');
      body.innerHTML = '<p class="is-qv-dialog__loading">Loading</p>';
      if (!dialog.open) dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      try {
        const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=is-quick-view`);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const view = doc.querySelector('.is-qv');
        if (!view) throw new Error('empty');
        body.innerHTML = '';
        body.appendChild(view);
      } catch (err) {
        window.location.href = url;
      }
    },
    close,
  };
})();

/* Any [data-quick-view] button on the page opens the modal (rails, grids, later pages). */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-quick-view]');
  if (!btn || btn.closest('is-collection')) return;
  e.preventDefault();
  window.ISQuickView.open(btn.dataset.quickView, btn);
});
